import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'tallymark-3', 'Tallymark3', [["path",{"d":"M8 5l0 14"}],["path",{"d":"M12 5l0 14"}],["path",{"d":"M16 5l0 14"}]]);